import { adminWorkspaceQueryKeys as e } from "./adminWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceAdminApi as n } from "@maat/api-main";
//#region src/workspaces/admin/useAdminWorkspaceQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.get(r),
	enabled: !!r
});
//#endregion
export { r as useAdminWorkspaceQuery };
